import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  fetchAgencyCountReport,
  fetchAgreementBenefitReport,
  fetchExpiringAgreements,
} from "../../slices/apps/dashboardSlice";
import { fetchAnnouncementIsDefault } from "../../slices/apps/announcementSlice";

// hooks
import { useProfile } from "../../Components/Hooks/UserHooks";

// sayfalar, modallar vs.
import Widgets from "./Widgets";
import Widgets2 from "./Widgets2";
import Widgets3 from "./Widgets3";
import AnnouncementModal from "./AnnouncementModal";
import ExpiringAgreementsView from "./ExpiringAgreementsView";

const Dashboard = () => {
  const dispatch = useDispatch();

  const { userProfile } = useProfile();

  // Redux loading state'leri - tümü false olana kadar spinner göster
  const {
    expiringAgreementsLoading,
    agreementBenefitReportLoading,
    agencyCountReportLoading,
  } = useSelector(
    (state) => ({
      expiringAgreementsLoading: state.dashboard.expiringAgreementsLoading,
      agreementBenefitReportLoading: state.dashboard.agreementBenefitReportLoading,
      agencyCountReportLoading: state.dashboard.agencyCountReportLoading,
    }),
    shallowEqual
  );

  // states
  const [showExpiringView, setShowExpiringView] = useState(false);

  const fetchData = async () => {
    try {
      // Tüm istekleri paralel olarak çalıştır
      await Promise.all([
        dispatch(fetchExpiringAgreements()),
        dispatch(fetchAgencyCountReport()),
        dispatch(fetchAgreementBenefitReport()),
        dispatch(fetchAnnouncementIsDefault()),
      ]);

      // if (userProfile.data.Role == "Agency") {
      //   BURADA ACENTE İÇİN HAK EDİŞ TUTARLARI İSTEĞİ EKLENECEK
      // }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  // Tüm veriler yüklenene kadar loading göster
  const isLoading =
    expiringAgreementsLoading ||
    agreementBenefitReportLoading ||
    agencyCountReportLoading;

  document.title = "Ana Sayfa | Global Yol Yardım";
  if (isLoading) {
    return (
      <React.Fragment>
        <Spinner
          className="position-absolute top-50 start-50"
          animation="border"
          color="primary"
        />
      </React.Fragment>
    );
  }

  // Yaklaşan sözleşmeler görünümü
  if (showExpiringView) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <ExpiringAgreementsView onBack={() => setShowExpiringView(false)} />
          </Container>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <AnnouncementModal />
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Row>
                  <Widgets onShowExpiring={() => setShowExpiringView(true)} />
                </Row>
                {/* {userProfile.data.Role == "Agency" && (
                  <Row>
                    <Widgets3 />
                  </Row>
                )} */}
                <Row>
                  <Widgets2 />
                </Row>
                {/* <Row>
                  <Col lg={6} xl={8}>
                    <Revenue />
                  </Col>
                  <Col lg={6} xl={4}>
                    <Pasta dataColors='["--vz-info", "--vz-primary"]' />
                  </Col>
                </Row> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
